import { observable } from "mobx";
import { Type } from "class-transformer";
import CustomerRefundCandidateChargeResponse from "./customerRefundCandidateChargeResponse";
import CustomerRefundCandidatePermittedActionsResponse from "./customerRefundCandidatePermittedActionsResponse";
import RefundPaymentType from "./refundPaymentType";
import CustomerRefundType from "./customerRefundType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class CustomerRefundCandidateResponse {
  id!: string;

  @observable
  officialRecordId!: string;

  @observable
  refundAmount!: number;

  @observable
  originalPaymentAmount?: number;

  @observable
  variableSymbol!: number;

  @observable
  @Type(() => CustomerRefundCandidateChargeResponse)
  charge!: CustomerRefundCandidateChargeResponse;

  @observable
  refundPaymentType!: RefundPaymentType;

  @observable
  refundType!: CustomerRefundType;

  @observable
  @Type(() => CustomerRefundCandidatePermittedActionsResponse)
  permittedActions!: CustomerRefundCandidatePermittedActionsResponse;
}

export default class CustomerRefundCandidate extends CustomerRefundCandidateResponse {
  // This flag is set later inside VM
  @observable
  isSelectable: boolean = true;
}
